import React, { useEffect, useMemo, useState } from 'react';
import { Col, Form } from 'antd';

import 'src/pages/userComponents/userStyle.scss';
import 'antd/dist/antd.css';

// import '../userStyle.scss';
import { images } from 'src/assets/img/index.js';
import EdenredButton from './../../../button/index';
import StepButton from '@pages/userComponents/Step-Button/StepButton';
import DotLoader from 'react-spinners/DotLoader';
import { useHistory } from 'react-router-dom';
import Iframe from 'react-iframe';

const EdenredPayroll = ({ url, loading, isCompAgreementLoading, compAgmnt, getEmpFileURL, docusignCreateLoading }) => {
	const history = useHistory();
	// console.log('COM DATA ::', compAgmnt);
	console.log('LOADING ::', docusignCreateLoading);
	return (
		<div>
			<Col>
				<div className="headercontainer agreementHeadercontainer" style={{ height: '60vh' }}>
					<text className="maintitle" style={{ width: '350px' }}>
						Edenred Payroll Agreement
					</text>
					<div className="agreementHeaderOuter">
						<div className="agreementHeaderInner">
							{
								loading ? (
									<div style={{
										height: '100%',
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center'
									}}>
										<DotLoader size={100} color={'#e91d24'} loading />
									</div>
								) : url ?
									<Iframe style={{ border: 'none', padding: '5px', borderRadius: '4px' }} src={url} height={'100%'} width={'100%'} />
									: null
							}
						</div>
					</div>
				</div>
			</Col>
			<StepButton buttonMode='triple'
				loading={docusignCreateLoading}
				disabled={docusignCreateLoading ? true : false}
				handleNext={() => {
					getEmpFileURL();
					// window.location.href = compAgmnt.docuSignEmbeddedSigningReturnUrl;
					// console.log('COMAGMNT ::', compAgmnt.docuSignEmbeddedSigningReturnUrl);
					// history.push('/user/signature/4')
				}}
				buttonText={'Sign Now'}
				linkUrl={url}
				secondaryHandleNext={() => {
					history.push('/user/signature/3');
				}}
			/>

		</div >
	);
};
export default EdenredPayroll;
